module.exports = __webpack_public_path__ + "static/media/img_59.313caee0.png";